import {
  MapPin, Mail, Phone, ArrowUp, Instagram,
  Receipt, Landmark, ClipboardCheck, Scale,
  Building2, ShieldCheck, Briefcase
} from "lucide-react";

const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Our Services", href: "#services" },
  { label: "About Us", href: "#founder" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact Us", href: "#contact" },
];

const SERVICE_LINKS = [
  { label: "GST Services", icon: Receipt },
  { label: "Income Tax", icon: Landmark },
  { label: "Audit Services", icon: ClipboardCheck },
  { label: "Legal & Litigation", icon: Scale },
  { label: "Business Registration", icon: Building2 },
  { label: "Compliance", icon: ShieldCheck },
  { label: "Advisory", icon: Briefcase },
];

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#080A10] border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_tax-compliance-hub-30/artifacts/0yf9q3g3_IMG-20260320-WA0000.jpg"
                alt="AVS Associates & Co"
                className="h-10 w-auto"
              />
            </div>
            <p className="font-work text-sm text-[#94A3B8] leading-relaxed mb-6">
              Premier taxation consultancy firm providing comprehensive financial,
              audit, and compliance services with international standards.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-[#94A3B8]">
                <Phone size={14} className="text-[#D4AF37]" />
                <a href="tel:+919990072390" className="font-work text-sm hover:text-white transition-colors">
                  +91 9990072390
                </a>
              </div>
              <div className="flex items-center gap-2 text-[#94A3B8]">
                <Mail size={14} className="text-[#D4AF37]" />
                <a href="mailto:avs_associates@yahoo.com" className="font-work text-sm hover:text-white transition-colors">
                  avs_associates@yahoo.com
                </a>
              </div>
              <div className="flex items-start gap-2 text-[#94A3B8]">
                <MapPin size={14} className="text-[#D4AF37] mt-1 shrink-0" />
                <span className="font-work text-sm">
                  Rajendra Place, New Delhi - 110008
                </span>
              </div>
              {/* Social */}
              <div className="flex items-center gap-3 mt-6">
                <a
                  href="https://www.instagram.com/avs_associatesco/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="w-9 h-9 bg-[#D4AF37]/10 flex items-center justify-center hover:bg-[#D4AF37]/20 transition-colors"
                >
                  <Instagram size={16} className="text-[#D4AF37]" />
                </a>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-outfit text-white font-medium text-base mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="font-work text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit text-white font-medium text-base mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((s) => {
                const Icon = s.icon;
                return (
                  <li key={s.label} className="flex items-center gap-2">
                    <Icon size={12} className="text-[#D4AF37]/50" />
                    <button
                      onClick={() => scrollTo("#services")}
                      className="font-work text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors"
                    >
                      {s.label}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Office Info */}
          <div>
            <h4 className="font-outfit text-white font-medium text-base mb-6">
              Visit Our Office
            </h4>
            <div className="bg-[#131821] border border-white/5 p-5">
              <p className="font-work text-sm text-[#94A3B8] leading-relaxed mb-4">
                Office No-120, First Floor,<br />
                Gagandeep Building,<br />
                Rajendra Place,<br />
                New Delhi - 110008
              </p>
              <p className="font-work text-xs text-[#D4AF37]/60">
                Nearest Metro Station: Rajendra Place
              </p>
              <div className="gold-line w-full mt-4 mb-4" />
              <p className="font-work text-xs text-[#94A3B8]">
                Mon - Sat: 10:00 AM - 7:00 PM
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-work text-xs text-[#94A3B8]/60">
            &copy; {new Date().getFullYear()} AVS Associates & Co. All rights reserved.
          </p>
          <button
            onClick={() => scrollTo("#home")}
            data-testid="back-to-top"
            className="flex items-center gap-2 text-[#D4AF37]/60 hover:text-[#D4AF37] transition-colors text-xs font-work"
          >
            Back to Top
            <ArrowUp size={12} />
          </button>
        </div>
      </div>
    </footer>
  );
}
